export const SERVICE_ASH_CLEANOUT_INSTALL = {
  label: 'Install Ash Cleanout Door',
  value: 'SERVICE_ASH_CLEANOUT_INSTALL'
};
export const SERVICE_ASH_DUMP_INSTALL = {
  label: 'Install Ash Dump Door',
  value: 'SERVICE_ASH_DUMP_INSTALL'
};
